const careCenter = '/centros-de-cuidado'

const listRoutes = {
	addPatient: '/agregar-paciente',
	allies: '/aliados',
	appointment: careCenter + '/citas',
	careNetwork: '/red-de-cuidado',
	careTraining: '/formacion-cuidador',
	classes: careCenter + '/clases',
	classesCycling: careCenter + '/reserva-bicicleta',
	classesQuotes: careCenter + '/reserva-clases',
	companyBenefits: '/beneficios-empresas',
	completeDataUser: '/completar-datos',
	dailyInformation: '/informacion-diaria',
	emailValidation: '/',
	habits: '/habitos',
	healthAsistan: '/asistente-de-salud',
	IMC: '/calcular-imc',
	initInformation: '/informacion-inicial',
	lifestyleQuestionnaire: '/cuestionario-vida',
	lives: '/envivos',
	login: '/login',
	myAppointment: careCenter + '/mis-citas',
	myPersonalRoutine: '/mi-rutina-personal',
	myRoutine: '/mi-rutina',
	myServices: '/mis-servicios',
	oneDoc3: '/1doc3',
	pac: '/pac',
	parQ: careCenter + '/par-q',
	parQWelcome: careCenter + '/inicio',
	parQPublic: '/par-q-public',
	profile: '/perfil',
	program: '/mis-programas',
	programInternal: '/mis-programas/programa',
	programQualify: '/califica',
	programSearch: '/mis-programas/suscribir',
	programSuscribeProgram: '/mis-programas/programa/suscribir',
	sadri: '/sadri',
	sadriAnalysis: '/analisis',
	services: '/servicios',
	slides: '/slide',
	subscription: '/suscripcion',
	careShop: '/tienda-del-cuidado',
	termsAndConditions: '/terminos-y-condiciones',
	tools: '/herramientas',
	validPatient: '/validar-paciente-cuidador',
	yourCondition: '/tu-condicion',
	yourHabits: '/tus-habitos',
	yourServices: '/tus-servicios'
}

export default listRoutes
